import { TranslationSet } from './en';

// TODO: translate values from English
export const ja: TranslationSet = {
  '(From Now)': '(これから)',
  '(From Scheduled)': '(予定より)',
  '{amount} Off. Expires: {expires}.': '{amount} オフ。有効期限: {expires}。',
  'A detailed report showing each activity and how long a technician or staff member took between and at each site with a total time at the site.': '各アクティビティと、技術者またはスタッフ メンバーが各サイト間および各サイトでかかった時間と、サイトでの合計時間を示す詳細レポート。',
  'A service type with inspection enabled will show up in the "to inspect" list on mobile. It is also used in reporting.': '検査が有効になっているサービス タイプは、モバイルの「検査対象」リストに表示されます。レポートにも使われます。',
  'Accept Invite': '招待を承諾する',
  'Add Condition': '条件の追加',
  'Add deficiencies to the equipment type': '設備タイプに欠陥を追加する',
  'Add Deficiency': '欠乏を追加する',
  'Add Equipment Field': '装備フィールドの追加',
  'Add Equipment Type': '機器タイプの追加',
  'Add Equipment': '機器の追加',
  'Add Floor Plan': 'フロアプランを追加',
  'Add history by clicking the plus in the top right or by performing a service.': '右上のプラスをクリックするか、サービスを実行して履歴を追加します。',
  'Add History': '履歴の追加',
  'Add Model Field': 'モデルフィールドの追加',
  'Add Model': 'モデルの追加',
  'Add Option': 'オプションの追加',
  'Add Question': '質問を追加',
  'Add questions using the plus icon in the top right': '右上のプラスアイコンを使用して質問を追加します',
  'Add service month categories in settings > service month categories. Service months allow you to keep different types of equipment in selected months for each location. Example: Alarms in May and October and Extinguishers in December.': '設定 > サービス月カテゴリでサービス月カテゴリを追加します。サービス月を使用すると、場所ごとに選択した月にさまざまなタイプの機器を保管できます。例: 5 月と 10 月は警報器、12 月は消火器。',
  'Add Service Month Category': 'サービス月カテゴリの追加',
  'Add Service Type': 'サービスタイプの追加',
  'Add service types in the settings': '設定にサービスの種類を追加する',
  'Add service types using the plus icon in the top right': '右上のプラスアイコンを使用してサービスタイプを追加します',
  'Add services to the equipment type': '機器タイプにサービスを追加する',
  'Add site Field': 'サイトフィールドを追加',
  'Add Site Override': 'サイトオーバーライドを追加',
  'Add Site Type': 'サイトタイプの追加',
  'Add Site': 'サイトを追加',
  'Add Sites': 'サイトの追加',
  'Add User': 'ユーザーの追加',
  'Add your own fields in Settings > Custom Fields > Site Fields': '[設定] > [カスタム フィールド] > [サイト フィールド] で独自のフィールドを追加します。',
  'Add': '追加',
  'Adding': '追加',
  'Address': '住所',
  'Advance from Now': '今から前進',
  'Advance from Scheduled': '予定より前倒し',
  'Agree': '同意する',
  'All Sites Scheduled!': 'すべてのサイトが予定されています!',
  'All': 'すべて',
  'Already have an account? Login': 'すでにアカウントをお持ちですか?ログイン',
  'An error happened while syncing': '同期中にエラーが発生しました',
  'April': '4月',
  'August': '8月',
  'Back': '戻る',
  'Billing Portal': '請求ポータル',
  'Building Reports': '構築レポート',
  'Cancel Plan': 'プランをキャンセルする',
  'Cancel Subscription': 'サブスクリプションをキャンセルする',
  'Cancel': 'キャンセル',
  'Change Model Fields': 'モデルフィールドの変更',
  'Change Password': 'パスワードの変更',
  'Checklist Information': 'チェックリスト情報',
  'Checklist Question': 'チェックリストの質問',
  'Checklist': 'チェックリスト',
  'Choose File': 'ファイルを選択',
  'City': '市',
  'Clear All Data': 'すべてのデータをクリア',
  'Clear': 'クリア',
  'Click or tap to add location': 'クリックまたはタップして場所を追加します',
  'Close': '閉じる',
  'Company-Wide Reports': '全社レポート',
  'Conditions': '条件',
  'Contact': 'お問い合わせ',
  'Copy Barcode': 'バーコードをコピーする',
  'Could not access': 'アクセスできませんでした',
  'Could not find equipment with the scanned barcode': 'スキャンされたバーコードのある機器が見つかりませんでした',
  'Could Not Service': 'サービスを提供できませんでした',
  'Create': '作成',
  'Creating Your Account': 'アカウントの作成',
  'Credentials are not valid': '資格情報が無効です',
  'CSV': 'CSV',
  'Custom Equipment Fields': 'カスタム機器フィールド',
  'Custom Fields': 'カスタムフィールド',
  'Custom Model Fields': 'カスタムモデルフィールド',
  'Custom site Fields': 'カスタムサイトフィールド',
  'Date': '日付',
  'Debug': 'デバッグ',
  'December': '12月',
  'Deficiencies': '欠陥',
  'Deficiency Report': '欠乏レポート',
  'Deficiency': '欠乏症',
  'Delete Equipment Field?': '装備フィールドを削除しますか?',
  'Delete Equipment Type?': '機器タイプを削除しますか?',
  'Delete Equipment Type': '機器タイプの削除',
  'Delete Equipment?': '装備を削除しますか?',
  'Delete Equipment': '装備の削除',
  'Delete Floor Plan?': 'フロアプランを削除しますか?',
  'Delete Model Field?': 'モデルフィールドを削除しますか?',
  'Delete Model?': 'モデルを削除しますか?',
  'Delete Model': 'モデルの削除',
  'Delete Override': 'オーバーライドの削除',
  'Delete Question?': '質問を削除しますか?',
  'Delete Question': '質問を削除',
  'Delete Record?': '記録を削除しますか?',
  'Delete Service Month?': 'サービス月を削除しますか?',
  'Delete Service Type?': 'サービスタイプを削除しますか?',
  'Delete Site Field?': 'サイトフィールドを削除しますか?',
  'Delete Site Type?': 'サイトタイプを削除しますか?',
  'Delete Site?': 'サイトを削除しますか?',
  'Delete Site': 'サイトの削除',
  'Delete User?': 'ユーザーを削除しますか?',
  'Delete User': 'ユーザーの削除',
  'Delete': '削除',
  'Deleted Equipment Field': '削除された装備フィールド',
  'Deleted Equipment': '削除された装備',
  'Deleted Floor Plan': '削除されたフロアプラン',
  'Deleted Model Field': '削除されたモデルフィールド',
  'Deleted Record': '削除されたレコード',
  'Deleted Service Month': '削除されたサービス月',
  'Deleted Service Type': '削除されたサービスの種類',
  'Deleted Site Field': '削除されたサイトフィールド',
  'Deleted Site Type': '削除されたサイトの種類',
  'Detailed': '詳細',
  'Did not want done': 'やりたくなかった',
  'Done by others': '他人がやったこと',
  'Don\'t have an account? Sign Up': 'アカウントをお持ちでない場合は、サインアップ',
  'Done': '完了',
  'Edit Dates': '日付の編集',
  'Edit Equipment': '装備の編集',
  'Edit': '編集',
  'Email is not valid': '電子メールが無効です',
  'End Date': '終了日',
  'Enter your email address': 'メールアドレスを入力してください',
  'Equipment already has this barcode': '機器にはすでにこのバーコードが付いています',
  'Equipment can be anything from a fire extinguisher to a treadmill. Set up equipment types in settings > equipment types.': '消火器からトレッドミルまで、あらゆる機器を使用できます。設定 > 機器タイプで機器タイプを設定します。',
  'Equipment Deleted': '削除された機器',
  'Equipment Due Consolidated Report': '設備期限の連結レポート',
  'Equipment Due Report': '機器期限レポート',
  'Equipment Field Information': '設備分野情報',
  'Equipment fields allow you to add different additional fields on the equipment type, such as "Voltage" or "Km".': '機器フィールドを使用すると、「電圧」や「キロメートル」などの機器タイプに関するさまざまな追加フィールドを追加できます。',
  'Equipment Fields': '装置分野',
  'Equipment for a site with all scheduled services.': 'スケジュールされたすべてのサービスを備えたサイトの機器。',
  'Equipment Options': '装備オプション',
  'Equipment Report': '設備レポート',
  'Equipment Service Report': '機器サービスレポート',
  'Equipment SKU': '機器のSKU',
  'Equipment Type Deleted': '機器タイプが削除されました',
  'Equipment Type': '機器の種類',
  'Equipment types quickly add inspection and service definitions to equipment when a model containing it is selected. Examples: Fire Extinguisher, Treadmill, Truck': '機器タイプは、それを含むモデルが選択されると、機器に検査定義とサービス定義をすぐに追加します。例: 消火器、トレッドミル、トラック',
  'Equipment Types': '機器の種類',
  'Equipment': '設備',
  'Export Billing Data': '請求データのエクスポート',
  'Export Data': 'データのエクスポート',
  'Export': 'エクスポート',
  'Failed to load organization.': '組織の読み込みに失敗しました。',
  'Failed to save the organization.': '組織の保存に失敗��ました。',
  'February': '2月',
  'Fill out the options below to prepare your report.': 'レポートを準備するには、以下のオプションを入力してください。',
  'Filter By': 'フィルター条件',
  'FlameTask Basic Subscription': 'FlameTask 基本サブスクリプション',
  'FlameTask Enterprise Subscription': 'FlameTask エンタープライズ サブスクリプション',
  'FlameTask Pro Subscription': 'FlameTask Pro サブスクリプション',
  'Floor Plan Location': 'フロアプランの位置',
  'Floor Plan': 'フロアプラン',
  'Floor Plans': 'フロアプラン',
  'Force Error': '強制エラー',
  'Forgot Password': 'パスワードを忘れた場合',
  'Generate': '生成する',
  'Hide "added" history records': '「追加された」履歴レコードを非表示にする',
  'Hide Advanced': '詳細を隠す',
  'History': '歴史',
  'How long a user spent at a site with time between actions.': 'ユーザーがサイトで過ごした時間とアクション間の時間。',
  'If this email matched an account, a link was sent to reset your password.': 'このメールがアカウントと一致した場合、パスワードをリセットするためのリンクが送信されました��',
  'Import Data': 'データのインポート',
  'Import': 'インポート',
  'Inspection Due': '検査期限',
  'Inspection Report': '検査報告書',
  'Inspection': '検査',
  'Inspections are up to date': '検査は最新のものです',
  'January': '1月',
  'July': '7月',
  'June': '6月',
  'Leave': '休暇を取る',
  'List of all equipment at the site with options to show services and filtering based on due service and/or inspection.': '適切なサービスや検査に基づいてサービスとフィルタリングを表示するオプションを備えた、サイトのすべての機器のリスト。',
  'List of all sites with their information. Options to filter by status and service month to find which sites are serviced in a specific month.': '情報を含むすべてのサイトのリスト。ステータスとサービス月でフィルタリングして、特定の月にサービスが提供されるサイトを見つけるオプション。',
  'List of equipment and deficiencies at the site, filtered by equipment with deficiencies that have a date opened and no closed date.': 'サイトの機器と欠陥のリスト。オープン日があり、クローズ日がない欠陥のある機器でフィルタリングされます。',
  'List of equipment between a range of dates with answers to the questions asked when performing a service or inspection.': 'サービスまたは検査を実行するときに尋ねられる質問への回答を含む、一定の日付間の機器のリスト。',
  'List of Equipment for a site with important information such as last inspection date and next due service, highlighting equipment due for inspection in red.': 'サイトの機器リストには、最終検査日や次回のサービスなどの重要な情報が記載されており、検査期限の機器が赤で強調表示されます。',
  'List of equipment that fits model search criteria. Example: a list of 5 pieces of equipment with model information matching 6LB ABC DRY.': '機種検索条件に該当する装備の一覧です。例: 6LB ABC DRY に一致するモデル情報を持つ 5 つの機器のリスト。',
  'Loading Equipment': '積載装置',
  'Loading Models...': 'モデルをロード中...',
  'Loading Scheduled Services...': 'スケジュールされたサービスを読み込んでいます...',
  'Loading Scheduled Sites': 'スケジュールされたサイトをロードしています',
  'Loading Service Types...': 'サービスタイプをロード中...',
  'Loading Sites': 'サイトを読み込んでいます',
  'Loading Unscheduled Services...': '予定外のサービスを読み込んでいます...',
  'Loading...': '読み込み中...',
  'Location': '場所',
  'Logging in...': 'ログイン中...',
  'Login Failed': 'ログインに失敗しました',
  'Login': 'ログイン',
  'Logout': 'ログアウト',
  'March': '3月',
  'May': '5月',
  'Meter Based Condition': 'メーターベースの状態',
  'Model Deleted': 'モデルが削除されました',
  'Model Field Information': 'モデルフィールド情報',
  'Model fields allow you to describe and report on equipment such as "Size", "Type" and "Category".': 'モデルフィールドでは、「サイズ」、「タイプ」、「カテゴリ」などの機器について説明およびレポートできます。',
  'Model Fields': 'モデルフィールド',
  'Model Information': 'モデル情報',
  'Model Name': 'モデル名',
  'Models allow quickly adding information to equipment such as which equipment type/services belong to it.': 'モデルを使用すると、どの機器タイプ/サービスが属するかなどの情報を機器にすばやく追加できます。',
  'Models': 'モデル',
  'Months of History (to start of month)': '月ごとの履歴 (月初めまで)',
  'More Details': 'さらに詳しく',
  'Name': '名前',
  'Nevermind': '気にしないでください',
  'No Custom Equipment Fields': 'カスタム機器フィールドはありません',
  'No Deficiencies': '欠陥なし',
  'No Equipment Fields': '機器フィールドなし',
  'No Equipment Types': '機器タイプなし',
  'No Equipment': '設備なし',
  'No Floor Plans': 'フロアプランなし',
  'No History': '履歴なし',
  'No Model Fields': 'モデルフィールドがありません',
  'No Models': 'モデルがありません',
  'No Open Deficiencies': '明らかな欠陥がないこと',
  'No Open or Closed Issues': '未解決の問題も解決済みの問題もありません',
  'No overrides for this Site': 'このサイトには上書きはありません',
  'No Questions': '質問はありません',
  'No Scheduled Services': '定期サービスはありません',
  'No Scheduled Sites': '予定されているサイトはありません',
  'No Service Month Categories': 'サービス月カテゴリなし',
  'No Service Types': 'サービスの種類がありません',
  'No Site Fields': 'サイトフィールドがありません',
  'No Site Types': 'サイトタイプなし',
  'No Sites': 'サイトがありません',
  'No Unscheduled Services': '不定期のサービスはありません',
  'No, Go Back': 'いいえ、戻ります',
  'No': 'いいえ',
  'Not in at the time of inspection': '検査時に入っていない',
  'Nothing to Inspect': '検査するものは何もありません',
  'Nothing to Service': 'サービスするものは何もありません',
  'November': '11月',
  'October': '10月',
  'Ok': 'わかりました',
  'Open a deficiency by clicking the plus in the top right of the pane. When the issue has been resolved, click on it and set the closed date.': 'ペインの右上にあるプラスをクリックして欠損を開きます。問題が解決したら、問題をクリックして終了日を設定します。',
  'Open a deficiency by tapping Options > Add Deficiency': '[オプション] > [不足を追加] をタップして不足を開きます',
  'Open Deficiencies': '開いた欠陥',
  'Open Deficiency': '開放性欠乏症',
  'Open in Apple Maps': 'Apple マップで開く',
  'Open in Google Maps': 'Google マップで開く',
  'Open Settings': '設定を開く',
  'Open': '開く',
  'Optional: Add a deficiency if this option is selected.': 'オプション: このオプションが選択されている場合は、欠落を追加します。',
  'Optional: This can be useful to set meter values easily': 'オプション: これは、メーター値を簡単に設定するのに役立ちます。',
  'Organization': '組織',
  'Outstanding Equipment': '優れた設備',
  'PDF': 'PDF',
  'Perform From Now': '今から実行',
  'Perform From Scheduled': 'スケジュールから実行',
  'Perform Service From Scheduled': 'スケジュールされた時間からサービスを実行',
  'Perform Service': 'サービスの実行',
  'Perform': '実行する',
  'Phone Number': '電話番号',
  'Please fill out all fields': 'すべてのフィールドに入力してください',
  'Please give a reason': '理由を教えてください',
  'Please select country first': '最初に国を選択してください',
  'Popup Note': 'ポップアップノート',
  'Preferences': '設定',
  'Preview Details': '詳細をプレビューする',
  'Profile': 'プロフィール',
  'Purchase Barcodes': 'バーコードを購入する',
  'Question Deleted': '質問は削除されました',
  'Question Information': '質問情報',
  'Questionnaire Report': 'アンケート報告書',
  'Questions': '質問',
  'Range End': '範囲終了',
  'Range Start': '範囲開始',
  'Reactivate': '再アクティブ化',
  'Remove': '削除',
  'Replace Barcode': 'バーコードを置き換える',
  'Replace Equipment': '機器の交換',
  'Replaced equipment': '交換した機器',
  'Report Date': '報告日',
  'Reports': 'レポート',
  'Save time and minimize risk by plotting the location of equipment on a floor plan of this site': 'このサイトの平面図に機器の位置をプロットすることで時間を節約し、リスクを最小限に抑えます',
  'Save': '保存',
  'Saving': '保存',
  'Scan barcode to make changes': 'バーコードをスキャンして変更を加える',
  'Scan Barcode': 'バーコードをスキャンする',
  'Scan': 'スキャン',
  'Schedule': 'スケジュール',
  'Scheduled Event': '予定されているイベント',
  'Scheduled service definitions can be added to the equipment type in settings > equipment types': 'スケジュールされたサービス定義は、設定 > 機器タイプで機器タイプに追加できます。',
  'Scheduled': '予定されている',
  'See More': 'もっと見る',
  'Selecting an option will add a history record and remove it from the todo list': 'オプションを選択すると、履歴レコードが追加され、ToDo リストから削除されます。',
  'Selective Equipment Report': '厳選装備レポート',
  'September': '9月',
  'Service Due': 'サービス期限',
  'Service month categories allow you to keep different types of equipment in different months. For example, you could inspect fire extinguishers in August and May and alarms in October.': 'サービス月カテゴリを使用すると、さまざまなタイプの機器をさまざまな月に保管できます。たとえば、8 月と 5 月に消火器を検査し、10 月に警報器を検査することができます。',
  'Service Month Categories': 'サービス月間のカテゴリー',
  'Service Month Category': 'サービス月カテゴリー',
  'Service Month': 'サービス月間',
  'Service months allow you to keep different types of equipment in selected months for each site. Example: Alarms in May and October and Extinguishers in December.': 'サービス月を使用すると、サイトごとに選択した月にさまざまなタイプの機器を保管できます。例: 5 月と 10 月は警��器、12 月は消火器。',
  'Service Months': 'サービス月数',
  'Service overrides allow you to disable a service or change the frequency for a specific site': 'サービス オーバーライドを使用すると、サービスを無効にしたり、特定のサイトの頻度を変更したりできます',
  'Service Type Settings': 'サービスタイプの設定',
  'Service Type': 'サービスの種類',
  'Service Types': 'サービスの種類',
  'Service': 'サービス',
  'Services are up to date': 'サービスは最新です',
  'Services': 'サービス',
  'Set answer to equipment field': '機器フィールドに回答を設定します',
  'Settings': '設定',
  'Show Advanced': '詳細を表示',
  'Show History Time': '履歴時間の表示',
  'Show Inspections': '検査を表示',
  'Show Questions / Answers': '質問/回答を表示する',
  'Show Services': 'ショーサービス',
  'Sign Up': 'サインアップ',
  'Simulate Scan': 'スキャンのシミュレート',
  'Site Deleted': 'サイトが削除されました',
  'Site Field Information': 'サイトフィールド情報',
  'Site fields will allow you to enter additional information into the site, such as "Parking Location".': 'サイトフィールドを使用すると、「駐車場所」などの追加情報をサイトに入力できます。',
  'Site Fields': 'サイトのフィールド',
  'Site Information': 'サイト情報',
  'Site Report': '現場レポート',
  'Site Reports': '現場レポート',
  'Site Service Override': 'サイトサービスのオーバーライド',
  'Site Service Overrides': 'サイトサービスの上書き',
  'Site Service Settings': 'サイトサービス設定',
  'Site Settings': 'サイト設定',
  'Site Type': 'サイトの種類',
  'Site types allow you to change service types based on the site. For example, only monthly customers would show the monthly inspection.': 'サイト タイプを使用すると、サイトに基づいてサービス タイプを変更できます。たとえば、月次の顧客のみが月次検査を表示します。',
  'Site types allow you to have different service types at different types of sites. For example, you may have to do monthly inspections at one site and only an annual inspection at another.': 'サイト タイプを使用すると、さまざまなタイプのサイトでさまざまなサービス タイプを使用できます。たとえば、あるサイトでは月次検査を実行し、別のサイトでは年次検査のみを行う必要がある場合があります。',
  'Site Types': 'サイトの種類',
  'Sites can help you organize equipment into places such as "Office" or "Warehouse". If you run a servicing company, you can add your clients as sites. ': 'サイトは、機器を「オフィス」や「倉庫」などの場所に整理するのに役立ちます。サービス会社を経営している場合は、クライアントをサイトとして追加できます。 ',
  'Sites': 'サイト',
  'Start Date': '開始日',
  'Start Trial': 'トライアルを開始する',
  'Status': 'ステータス',
  'Summary of services at a site separated by model information. Example 5 Monthly Inspections with model information 6LB DRY ABC.': '機種情報ごとに分かれたサイトのサービス概要。例 5 モデル情報 6LB DRY ABC を含む月次検査。',
  'Swap Equipment': '装備を交換する',
  'Swapped equipment': '交換された装備',
  'TEST': 'テスト',
  'The EMS plan is a discounted plan for non-profit or publicly funded emergency services.  Please choose another plan if you do not match this criteria': 'EMS プランは、非営利または公的資金による医療サービス向けの割引プランです。  この条件に当てはまらない場合は、別のプランを選択してください',
  'The popup note is used to remind you of important information regarding the location. It will appear when opening the location screen.': '���ップアップ メモは、場所に関する重要な情報を通知するために使用されます。位置情報画面を開くと表示されます。',
  'There are no unscheduled sites with outstanding inspections, service or deficiencies.': '予定外の検査、サービス、または欠陥のある現場はありません。',
  'There is no equipment at this site with this search criteria and due inspections': 'このサイトには、この検索条件と適切な検査を備えた機器はありません',
  'There is no equipment at this site with this search criteria and due service': 'このサイトには、この検索条件と適切なサービスを��えた機器はありません',
  'This Month': '今月',
  'Time at Site Detailed': '現場滞在時間の詳細',
  'Time at Site': '現場滞在時間',
  'Time Based Condition': '時間ベースの条件',
  'Today': '今日',
  'Transfer Equipment': '搬送装置',
  'Unscheduled service definitions can be added to the equipment type in settings > equipment types': 'スケジュール外のサービス定義は、設定 > 機器タイプで機器タイプに追加できます。',
  'Unscheduled': '予定外',
  'Updated barcode': '更新されたバーコード',
  'Used Equipment SKU': '中古機器のSKU',
  'Used for the billing export for new, swapped and replaced equipment.': '新規、交換、交換された機器の請求エクスポートに使用されます。',
  'User Deleted': 'ユーザーが削除されました',
  'User Information': 'ユーザー情報',
  'User': 'ユーザー',
  'Users': 'ユーザー',
  'View on FloorPlan': 'フロアプランで見る',
  'View Terms': '規約を見る',
  'Whenever equipment is swapped the billing export will increment the quantitiy under this SKU.': '機器が交換されるたびに、請求エクスポートによってこの SKU の数量が増加します。',
  'Yes, Delete Equipment Field': 'はい、機器フィールドを削除します',
  'Yes, Delete Equipment Type': 'はい、機器タイプを削除します',
  'Yes, Delete Equipment': 'はい、機器を削除します',
  'Yes, Delete Floor Plan': 'はい、フロアプランを削除します',
  'Yes, Delete Model Field': 'はい、モデルフィールドを削除します',
  'Yes, Delete Model': 'はい、モデルを削除します',
  'Yes, Delete Question': 'はい、質問を削除します',
  'Yes, Delete Record': 'はい、レコードを削除します',
  'Yes, Delete Service Month': 'はい、サービス月を削除します',
  'Yes, Delete Service Type': 'はい、サービスタイプを削除します',
  'Yes, Delete Site Field': 'はい、サイトフィールドを削除します',
  'Yes, Delete Site Type': 'はい、サイトタイプを削除します',
  'Yes, Delete Site': 'はい、サイトを削除します',
  'Yes, Delete User': 'はい、ユーザーを削除します',
  'Zone': 'ゾーン',
  'Customer': 'お客様',
  'Site': 'サイト',
  'All Sites': 'すべてのサイト',
  'Loading Customers': '顧客をロード中',
  'No Customers': '客がいない',
  'Add Customer': '顧客の追加',
  'Customers are groups of sites with billing information.': '顧客は、請求情報を持つサイトのグループです。',
  'Customers': 'お客様',
  'Customer Information': '顧客情報',
  'Delete Customer': '顧客の削除',
  'Yes, Delete Customer': 'はい、顧客を削除します',
  'Delete Customer?': '顧客を削除しますか?',
  'Customer Deleted': '顧客が削除されました',
  'Create Customer': '顧客の作成',
  'Assign Existing Customer': '既存の顧客を割り当てる',
  'Edit Customer': '顧客の編集',
  'Enter a serial number': 'シリアル番号を入力してください',
  'Remove Customer': '顧客の削除',
  'Find': '探す',
  'Sync Now': '今すぐ同期',
  'Syncing...': '同期中...',
  'Find equipment by serial number': 'シリアル番号で機器を検索',
  'Last successful upload was {formattedDate}': '最後に成功したアップロードは {formattedDate} でした',
  'Up to date as of {formattedDate}': '{formattedDate} 時点での最新情報',
  'Zones are used to group locations in the location report': 'ゾーンは、場所レポートで場所をグループ化するために使用されます。',

  'Account Number': '口座番号',
  'Add Location Override': '場所のオーバーライドを追加',
  'Add New Model': '新しいモデルの追加',
  'Add Site Field': 'サイトフィールドの追加',
  'Address Line 2': '住所 2 行目',
  'Agree to': '同意する',
  'All conditions are true': 'すべての条件が真です',
  'All Permissions': 'すべての権限',
  'Allow Text Input': 'テキスト入力を許可する',
  'An email with the reset password link below has been sent to': '以下のパスワードをリセットするリンクが記載されたメールが次の宛先に送信されました。',
  'An error ocurred while trying to show this page.': 'このページを表示しようとしたときにエラーが発生しました。',
  'Any condition is true': 'どの条件も真です',
  'Background Color': '背景色',
  'Billing and customer controls': '請求と顧客管理',
  'Building Reports - Safety Scan': '建物レポート - 安全性スキャン',
  'Change Another Service': '別のサービスを変更する',
  'Choose Site': 'サイトを選択',
  'click here': 'ここをクリック',
  'Closed Date': '休業日',
  'Closed Deficiencies': '解決された欠陥',
  'Company Information': '会社情報',
  'Company Name': '会社名',
  'Completing Sign Up': 'サインアップを完了する',
  'Context ID': 'コンテキストID',
  'Could not find equipment with that barcode': 'そのバーコードを持つ機器が見つかりませんでした',
  'Creating invite link...': '招待リンクを作成しています...',
  'Current equipment failed to load': '現在の機器はロードできませんでした',
  'Data File': 'データファイル',
  'Data Origin': 'データの起源',
  'Date affected by': '影響を受ける日付',
  'Date Completed': '完了日',
  'Date Started': '開始日',
  'Delete equipment?': '装備を削除しますか？',
  'Dev Environment': '開発環境',
  'Disabled For': '無効な対象者',
  'Disabled For Location': '位置情報が無効です',
  'Do not change': '変更しないでください',
  'Due When': '期限はいつ',
  'Edit Deficiencies': '欠陥の編集',
  'Edit History': '編集履歴',
  'Edit Location': '場所の編集',
  'Edit Schedule': 'スケジュールの編集',
  'Edit Service': 'サービスの編集',
  'Edit Settings': '設定の編集',
  'End Time': '終了時間',
  'Equal to': 'に等しい',
  'Equipment Field': '機器分野',
  'Equipment replaced': '機器を交換しました',
  'Equipment swapped': '装備を交換しました',
  'Example: Broken Handle': '例: 壊れたハンドル',
  'Frequency Type': '周波数の種類',
  'Generate Reports': 'レポートの生成',
  'Get started by checking out our tutorials on YouTube or setting up your account in settings.': 'まずは YouTube でチュートリアルを確認するか、設定でアカウントを設定してください。',
  'Global Search': 'グローバル検索',
  'Greater than': 'より大きい',
  'hasn&apos;t accepted their invite yet. You can': 'まだ招待を受け入れていません。',
  'Include In Reports': 'レポートに含める',
  'landscape LetterHead': '風景レターヘッド',
  'Last Date': '最終日',
  'Last Date Minimum Granularity': '最終日の最小粒度',
  'Last Download': '最終ダウンロード',
  'Last Upload': '最終アップロード',
  'Less than': '未満',
  'Locations can only be added on a desktop browser': '場所はデスクトップブラウザでのみ追加できます',
  'Looks like you never finished signing up': 'サインアップがまだ完了していないようです',
  'Metered Condition': '従量制条件',
  'Mobile Access': 'モバイルアクセス',
  'Model Number': 'モデル番号',
  'Next Date (Overide)': '次の日付 (上書き)',
  'No Conditions': '条件なし',
  'No Options': 'オプションなし',
  'Not equal to': '等しくありません',
  'Opened Date': '開設日',
  'Option Selected': '選択されたオプション',
  'Perform On Scan': 'スキャン時に実行',
  'Please click the button below to start your free 3 month trial': '3 か月の無料トライアルを開始するには、下のボタンをクリックしてください',
  'Please review the terms below': '以下の規約をご確認ください',
  'Portrait LetterHead': '縦長のレターヘッド',
  'Postal Code': '郵便番号',
  'Powered By': '搭載',
  'Preventive Maintenance': '予防保守',
  'Profile Image': 'プロフィール画像',
  'Receive marketing emails': 'マーケティング電子メールを受信する',
  'Rivison Inc.': '株式会社リヴィゾン',
  'Search Sites...': 'サイトを検索...',
  'Serial Number': 'シリアルナンバー',
  'Service is Unscheduled': 'サービスは予定されていません',
  'Service Options': 'サービスオプション',
  'Service or Inspection Due': 'サービスまたは検査の期限',
  'Show All': 'すべて表示',
  'Show site selector in top corner': 'サイトセレクターを上隅に表示',
  'Sign-Up Failed. Ensure the email is not already is use.': 'サインアップに失敗しました。',
  'Sorry, an error occurred while trying to create an invite link. Please try again later, or reach out to support': '申し訳ありませんが、招待リンクを作成しようとしたときにエラーが発生しました。',
  'Sorry, looks like you&apos;re offline. Please try again when you have an internet connection': '申し訳ありませんが、オフラインのようです。',
  'Start Time': '開始時間',
  'Successfully updated profile': 'プロファイルが正常に更新されました',
  'terms and conditions': '利用規約',
  'Text Input': 'テキスト入力',
  'The date below is used to show history records only.': '以下の日付は、履歴レコードを表示するためにのみ使用されます。',
  'This will just take a moment': 'これには少し時間がかかります',
  'Time Condition': '時間条件',
  'Time Zone': 'タイムゾーン',
  'to generate another invite link.': 'をクリックして別の招待リンクを生成します。',
  'Toggle Flashlight': '懐中電灯の切り替え',
  'Type more characters to narrow the search further': '検索をさらに絞り込むには、さらに文字を入力します',
  'Use text answer for': 'テキスト回答を使用する',
  'Version:': 'バージョン:',
  'View Deficiencies': '欠陥を表示する',
  'View Equipment': '設備を見る',
  'View History': '履歴を見る',
  'View Location': '場所を表示',
  'View Schedule': 'スケジュールを見る',
  'View Service': 'サービスを見る',
  'View Settings': '設定の表示',
  'We hope to see you again.': 'またお会いできるのを楽しみにしています。',
  'Web Login': 'ウェブログイン',
  'Welcome,': 'いらっしゃいませ、',
  'White Label': 'ホワイトラベル',
  'Work Day End Time': '勤務日の終了時刻',
  'Work Day Start Time': '勤務日の開始時刻',
  'You must agree to the terms and conditions': '利用規約に同意する必要があります',
  'Your Subscription Has Been Canceled': 'サブスクリプションがキャンセルされました',
};
